/**
 * Build-time feature flags.
 *
 * Anything here is read once at module load from `import.meta.env`, so Vite
 * can tree-shake the guarded code out of a production bundle when the flag is
 * off — a flag checked at render time would still ship the component.
 */

/**
 * The in-app QA / Testing Console at `/testing`.
 *
 * Defaults ON so a dev clone and the tester preview both have it. Turn it off
 * for a build that goes in front of a customer:
 *
 *     VITE_TESTING_CONSOLE=off   (in .env.local / the deploy environment)
 *
 * When off the `/testing` route is never registered, so the URL 404s rather
 * than rendering a hidden page.
 */
export const TESTING_CONSOLE_ENABLED =
  (import.meta.env.VITE_TESTING_CONSOLE ?? 'on').toLowerCase() !== 'off';

/**
 * Namespace for QA runs on the API.
 *
 * Lets a second environment (say a staging deploy) keep its own runs without
 * colliding with the shared ones. Defaults to `default`.
 */
export const QA_NAMESPACE = import.meta.env.VITE_QA_NAMESPACE || 'default';

/**
 * Shared key for the QA endpoints, matched against `QaTesting:Key` on the API.
 *
 * The console is reachable signed out — a tester has to be able to record that
 * the login page is broken — so its endpoints cannot require a JWT and this
 * guards them instead. It compiles into the bundle, which makes it a speed bump
 * rather than security; that is the same trade the site gate already makes, and
 * what sits behind it is pass/fail marks on an internal checklist.
 *
 * Unset means no sharing: the console saves to this browser only and says so in
 * its header.
 */
export const QA_KEY = import.meta.env.VITE_QA_KEY ?? '';
